<template>
	<q-dialog :value="dialogVisible"
			  @hide="dialogHidden"
			  :position="dialogPosition"
			  :full-width="dialogFullWidth"
			  :persistent="dialogPersistent"
			  square
	>
		<q-card>
			<dialog-header v-if="dialogTitle"
						   :dialog-title="dialogTitle"
						   :dialog-close-button="dialogCloseButton"
						   :dialog-persistent="dialogPersistent"
						   @close="dialogHidden"
			/>
			<q-card-section>
				<component :is="component"
						   :props="dialogComponentProps"
						   :class="dialogContentClass"
						   :style="dialogContentStyle"
				/>
			</q-card-section>
		</q-card>
	</q-dialog>
</template>

<script>
	import {mapMutations, mapState} from 'vuex';
	import {HIDE_DIALOG} from "@/store/mutations.type";
	import WatchlistAdd from "@/components/dialog/WatchlistAdd";
	import MeasurementList from "@/components/dialog/MeasurementList";
	import WatchlistSettings from "@/components/dialog/WatchlistSettings";
	import WatchlistShare from "@/components/dialog/WatchlistShare";
	import LogImagesPicker from "@/components/dialog/LogImagesPicker";
	import PalletLogList from "@/components/dialog/PalletLogList";
	import DialogHeader from "@/components/dialog/DialogHeader";

	export default {
		name: "DialogShell",
		components: {DialogHeader, WatchlistAdd, MeasurementList, WatchlistSettings, WatchlistShare, LogImagesPicker, PalletLogList},
		data() {
			return {
				component: null
			}
		},
		computed: {
			...mapState([
				'dialogVisible',
				'dialogComponent',
				'dialogTitle',
				'dialogComponentProps',
				'dialogPosition',
				'dialogFullWidth',
				'dialogPersistent',
				'dialogCloseButton',
				'dialogContentClass',
				'dialogContentStyle'
			])
		},
		methods: {
			...mapMutations([HIDE_DIALOG]),
			dialogHidden() {
				this.$store.commit(HIDE_DIALOG);
			}
		},
		watch: {
			dialogComponent(component) {
				if (!component) return;

				this.component = component;
			}
		}
	}
</script>